import React from "react";
import { Link } from "react-router-dom";
export function InvoiceComp() {
  return (
    <div>
      <div className="p-4 text-gray-600 rounded-md shadow-[0px_4px_24px_0px_rgba(34,41,47,10%)] ">
        <div className="md:flex justify-between">
          <h1 className="text-[#610621] font-semibold text-xl">
            EAST DELTA UNIVERSITY
          </h1>
          <h1 className=" text-gray-600 font-semibold mb-2">
            Invoice Number: 78648
          </h1>
        </div>
        <div className="text-sm ">
          <h1 className="mb-1">Student Id: 222004012</h1>
          <div className=" text-gray-600 font-semibold mb-1">MD Yasin</div>{" "}
          <div>
            Chawk Bazar kapashgola, Abdul Hakim Shodagor ln Chittagong, 4203
          </div>
        </div>
      </div>
      <div></div>
    </div>
  );
}
export function InvoiceSubejct() {
  return (
    <div className=" overflow-x-auto relative">
      <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
          <tr>
            <th scope="col" className="py-3 px-6">
              SUBJECT
            </th>
            <th scope="col" className="py-3 px-6">
              DATE
            </th>
            <th scope="col" className="py-3 px-6">
              CREDIT/HOUR
            </th>
            <th scope="col" className="py-3 px-6">
              AMOUNT
            </th>
          </tr>
        </thead>
        <tbody>
          <tr className="bg-white border-b ">
            <th
              scope="row"
              className="py-4 px-6 font-medium text-gray-900 whitespace-nowrap "
            >
              CSE 111 Computer Fundamentals
            </th>
            <td className="py-4 px-6">12/2/2022</td>
            <td className="py-4 px-6">BDT 4000</td>

            <td className="py-4 px-6">12,585Tk</td>
          </tr>
          <tr className="bg-white border-b ">
            <th
              scope="row"
              className="py-4 px-6 font-medium text-gray-900 whitespace-nowrap "
            >
              112 Computer Fundamentals
            </th>
            <td className="py-4 px-6">1/2/2022</td>
            <td className="py-4 px-6">BDT 3000</td>

            <td className="py-4 px-6">12,585Tk</td>
          </tr>
          <tr className="bg-white border-b ">
            <th
              scope="row"
              className="py-4 px-6 font-medium text-gray-900 whitespace-nowrap "
            >
              Programming Basics Laboratory1.5
            </th>
            <td className="py-4 px-6">15/2/2022</td>
            <td className="py-4 px-6">BDT 9000</td>

            <td className="py-4 px-6">12,585Tk</td>
          </tr>
          <tr className="bg-white border-b ">
            <th
              scope="row"
              className="py-4 px-6 font-medium text-gray-900 whitespace-nowrap "
            >
              Geometry Complex Variables 3.0
            </th>
            <td className="py-4 px-6">1/2/2022</td>
            <td className="py-4 px-6">BDT 3000</td>

            <td className="py-4 px-6">12,585Tk</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
export function Disccount() {
  return (
    <div className=" overflow-x-auto relative mt-5">
      <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
          <tr>
            <th scope="col" className="py-3 px-6">
              Disccount
            </th>

            <th scope="col" className="py-3 px-6">
              AMOUNT
            </th>
          </tr>
        </thead>
        <tbody>
          <tr className="bg-white border-b ">
            <th
              scope="row"
              className="py-4 px-6 font-medium text-gray-900 whitespace-nowrap "
            >
              CSE 111 Computer Fundamentals
            </th>

            <td className="py-4 px-6">12,585Tk</td>
          </tr>

          <tr className="bg-white border-b ">
            <th
              scope="row"
              className="py-4 px-6 font-medium text-gray-900 whitespace-nowrap "
            >
              Geometry Complex Variables 3.0
            </th>

            <td className="py-4 px-6">12,585Tk</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export function Paycard() {
  return (
    <div className=" p-7  text-gray-500  text-center  rounded-md shadow-[0px_4px_24px_0px_rgba(34,41,47,10%)]">
      <div className=" border border-gray-400 p-3 mb-3 rounded-md font-medium ">
        Download
      </div>
      <div className=" border border-gray-400 p-3 mb-3 rounded-md font-medium ">
        Print
      </div>
      <div className="flex justify-between mt-3 mb-3">
        <div>Total</div>
        <div className=" text-blue-600">BDT 45,500</div>
      </div>
      <div className=" p-3 mb-3 rounded-md font-medium bg-green-500 text-white ">
        <Link to="/visa"> Add Payment</Link>
      </div>
    </div>
  );
}
